import React from 'react';
import { FormElements, Text } from '@custom-components';
import PropTypes from 'prop-types';
import { Divider } from '@mui/material';
import { StyledMenuItem, StyledChildMenuItem, ChildMenuItemContainer } from '../MultiSearchSelect.styles';

function TwoLayerMultiSearchSelectMenuItems(props) {
  const { optionsTitle, name, value, options, handleChange } = props;

  const sortedOptions = [
    ...options.filter((option) => value.includes(option.value)).sort((a, b) => a.label.localeCompare(b.label)),
    ...options.filter((option) => !value.includes(option.value)).sort((a, b) => a.label.localeCompare(b.label))
  ];

  const allChecked = sortedOptions.every((option) => value.includes(option.value));

  const handleSelectAll = () => {
    const newValue = sortedOptions.map((option) => option.value);
    handleChange({ target: { name, value: newValue, allChecked: !allChecked } });
  };

  return (
    <div>
      <StyledMenuItem onClick={handleSelectAll}>
        <FormElements.Checkbox checked={allChecked} onChange={(e) => e.stopPropagation()} />
        <Text.CopyBody>{optionsTitle}</Text.CopyBody>
      </StyledMenuItem>
      <Divider />
      {sortedOptions.map((option) => (
        <ChildMenuItemContainer checked={allChecked}>
          <StyledChildMenuItem
            key={`menu-item-${option?.value}`}
            onClick={() => {
              const event = { target: { name, value: [option?.value] } };
              handleChange(event);
            }}
          >
            <FormElements.Checkbox checked={value.includes(option?.value)} />
            <Text.CopyBody>{option?.label}</Text.CopyBody>
          </StyledChildMenuItem>
        </ChildMenuItemContainer>
      ))}
      <Divider />
    </div>
  );
}

TwoLayerMultiSearchSelectMenuItems.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.shape([]),
  handleChange: PropTypes.func,
  optionsTitle: PropTypes.string
};
TwoLayerMultiSearchSelectMenuItems.defaultProps = {
  name: '',
  value: '',
  options: [],
  handleChange: () => {},
  optionsTitle: ''
};

export default TwoLayerMultiSearchSelectMenuItems;
